export const AlgoParameters = () => {
  return {
    isPlaying: 0,
    animIdx: 0,
    count: 21,
    ordre: [],
    animFrames: [],
  };
};
